export default __webpack_public_path__ + "static/media/dash_arrow_circle_big.560e5ad4.svg";